export const blockIconsImageCircle = (
	<span className='material-symbols-outlined'>circle</span>
);
